import React from "react";

interface MessageProps {
  type?: "info" | "error" | "success"; // extend as needed
  text?: string;
}

const Message: React.FC<MessageProps> = ({ type = "info", text }) => {
  if (!text) return null;

  const color = type === "error" ? "red" : "green";

  return (
    <>
      <p style={{ color }}>{text}</p>
      <hr />
    </>
  );
};

export default Message;
